import { useDeferredValue, useMemo } from 'react';
import { useSelector } from 'react-redux';

export default () => {
  const gallery = useSelector((state) => state.gallery);
  const memoizedAssets = useMemo(() => gallery.assets, [gallery.id]);
  const deferredAssets = useDeferredValue(memoizedAssets);
  return deferredAssets;
};
